import React, { useState, useEffect } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLanguage } from '../context/LanguageContext';
import AdUnit from './AdUnit';

interface BannerHeaderProps {
  startDate?: string; // ISO date string for campaign start
  endDate?: string;   // ISO date string for campaign end
  iframeUrl?: string; // URL for the iframe content
  width?: string;     // Width of the banner
  height?: string;    // Height of the banner
}

const BannerHeader: React.FC<BannerHeaderProps> = ({
  startDate = '2025-04-04T00:00:00Z', // Default start date
  endDate = '2025-04-18T23:59:59Z',   // Default end date
  iframeUrl = 'https://ads.piscan.io/banner1/banner/',
  width = '320px',
  height = '100px'
}) => {
  const [showIframe, setShowIframe] = useState<boolean>(false);
  const { t } = useLanguage();
  
  useEffect(() => {
    // Check if current time is within the specified range
    const now = new Date();
    const campaignStart = new Date(startDate);
    const campaignEnd = new Date(endDate);
    
    const isWithinCampaignPeriod = now >= campaignStart && now <= campaignEnd;
    setShowIframe(isWithinCampaignPeriod);
  }, [startDate, endDate]);
  
  // Ad badge with tooltip
  const adBadge = (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="ad-tooltip">Third-party ad. Interact at your own risk.</Tooltip>}
    >
      <div 
        className="position-absolute" 
        style={{ 
          top: "0", 
          right: "0", 
          zIndex: 10, 
          padding: "2px 5px",
          backgroundColor: "rgba(108, 117, 125, 0.8)",
          borderRadius: "0 4px 0 4px",
          cursor: "help",
          fontSize: "10px",
          color: "white",
          fontWeight: "bold"
        }}
      >
        Ad
      </div>
    </OverlayTrigger>
  );
  
  if (showIframe) {
    return (
      <div className="banner-header-container position-relative" style={{ width, height }}>
        {adBadge}
        <iframe 
          src={iframeUrl} 
          title="Special campaign banner"
          width={width}
          height={height}
          frameBorder="0"
          scrolling="no"
          style={{
            overflow: 'hidden',
            border: '1px solid #e9ecef',
            borderRadius: '4px'
          }}
        />
      </div>
    );
  }
  
  // Fall back to AdUnit outside the campaign period
  return (
    <AdUnit 
      width={width}
      height={height}
      className="67cc9861aa72d3d47fe11a0b"
      centered={true}
      showOnMobile={false}
    />
  );
};

export default BannerHeader;